<template>
  <div id="HampaPay" class="container-fluid" dir="rtl">
    <loading v-if="loadingRender"></loading>
    <div v-if="FastpaymentData.length != 0 && IsFastPayment" class="col-12 p-2">
      <net-pa-card>
        <template v-slot:header>
          <h6><i class="fas fa-credit-card ml-2"></i>پرداخت سریع</h6>
        </template>
        <template v-slot:content>
          <div class="row">
            <div class="col-md-4 col-12">
              <div class="border bnp-rounded p-0 text-center bg-dark text-light">
                <div class="row">
                  <div class="col-12 text-center p-1 pt-2">
                    <h6 class="font-weight-bold text-light"><i class="fas fa-circle font-weight-bold text-warning ml-2"></i>کل مبلغ سررسید شده</h6>
                  </div>
                  <div class="col-12" style="min-height: 24vh">
                    <div class="row">
                      <div class="col-12 text-center mt-2 mx-2">
                        <span class="text-light">مبلغ سررسید شده بابت </span>
                        <span class="text-warning" style="font-size: 15px">{{ TotalFastPay.VamCoutFastPay }}</span>
                        <span class="text-light"> وام </span>
                      </div>
                      <div class="col-12 text-center mt-1 mx-2">
                        <span class="text-light">مبلغ جریمه </span>
                        <span class="text-danger" style="font-size: 15px">{{ $Comma3ragham(TotalFastPay.SumJarmieFastPay) }}</span>
                      </div>
                      <div class="col-12 text-center mt-1">
                        <span class="text-light"> مبلغ قابل پرداخت: </span>
                      </div>
                      <div class="col-3"></div>
                      <div class="col-6 mt-2 text-center">
                        <label style="font-size: 20px" class="border-bottom boroder-light">{{ $Comma3ragham(TotalFastPay.SumMabFastPay + '') }}</label>
                      </div>
                      <div class="col-3"></div>
                      <div class="col-12 text-center tex-light my-1">
                        <span class="text-light">{{ $Mab2persianToman(TotalFastPay.SumMabFastPay + '') }}</span>
                      </div>
                      <div class="col-3 mt-1"></div>
                      <div class="col-6 mt-1">
                        <button class="bnp-rounded text-light btn w-100 mb-1" :disabled="TotalFastPay.SumMabFastPay == 0" @click="FastPay" style="background: #435ebe !important">&nbsp; پرداخت سریع &nbsp;</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-8 mt-md-0 mt-2 col-12" style="max-height: 220px; overflow-y: scroll">
              <div class="row">
                <div v-for="(item, index) in FastpaymentData" :key="index" class="col-12 border-right border-success Netpa-Shadow-2 bg-white p-1 mt-2 px-4" style="border-right: solid 2px !important">
                  <div class="row">
                    <div class="col-6 mt-md-0 mt-2 text-center col-md-2">
                      <span class="text-secondary">نام تسهیلات: </span> <br />
                      <small class="text-right">{{ item.desNoe }}</small>
                    </div>
                    <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                      <span class="text-secondary">شماره تسهیلات</span><br />
                      <small class="no-wrap" dir="rtl">{{ item.vCode }}</small>
                    </div>
                    <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                      <span class="text-secondary">تاریح قسط</span><br />
                      <small class="no-wrap" dir="rtl">{{ item.tarix }}</small>
                    </div>
                    <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                      <span class="text-secondary">مبلغ قابل پرداخت</span><br />
                      <small dir="rtl">{{ $Comma3ragham(item.mablghPardakht + '') }}</small>
                    </div>
                    <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
                      <span class="text-secondary">مبلغ جریمه</span><br />
                      <span class="text-danger" dir="rtl">{{ item.wwwjarime == null ? 0 : $Comma3ragham(item.wwwjarime + '') }}</span>
                    </div>
                    <div class="col-12 mt-md-0 mt-2 col-md-1" dir="rtl">
                      <span class="">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input InputText" :checked="FastpaymentData[index].Active" v-model="FastpaymentData[index].Active" :id="FastpaymentData[index].vCode + 'active'" />
                          <label class="custom-control-label mt-2 Pointer" :for="FastpaymentData[index].vCode + 'active'">انتخاب</label>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </net-pa-card>
    </div>
    <div v-else-if="!IsFastPayment" class="row m-1">
      <div class="col-12 card Netpa-Shadow p-4">
        <div class="row mt-2">
          <div class="col-12 text-right">
            <b v-if="!IsTashilat" style="font-size: 15px !important" class="text-dark"> اطلاعات حساب</b>
            <b v-else style="font-size: 15px !important" class="text-dark"> اطلاعات تسهیلات</b>
            <hr />
          </div>
          <div class="col-12 text-right">
            <ul class="list-inline pr-0 m-0">
              <li v-if="!IsTashilat" class="list-inline-item text-secondary">شمــاره حساب :</li>
              <li v-else class="list-inline-item text-secondary">شمــاره تسهیلات :</li>
              <li class="list-inline-item text-danger bnp-lblFontHampa">
                {{ vCode }}
              </li>
            </ul>
            <hr />
          </div>
          <div class="col-12 text-right">
            <ul class="list-inline pr-0 m-0">
              <li class="list-inline-item text-secondary">شنـــاسه واریز :</li>
              <li class="list-inline-item text-danger bnp-lblFontHampa">
                {{ shenaseVariz }}
              </li>
            </ul>
            <hr />
          </div>
          <div class="col-12 text-right">
            <ul class="list-inline pr-0 m-0">
              <li class="list-inline-item text-secondary">مشخصات :</li>
              <li class="list-inline-item text-danger bnp-lblFontHampa">
                {{ nameFamily }}
              </li>
            </ul>
            <hr />
          </div>
          <div class="col-12 text-right">
            <ul class="list-inline pr-0 m-0">
              <li class="list-inline-item text-secondary">سر رسید اولین بدهی :</li>
              <li class="list-inline-item text-danger bnp-lblFontHampa">
                {{ tarihkSarsid }}
              </li>
            </ul>
            <hr />
          </div>
          <div v-if="IsTashilat" class="col-12 text-right">
            <ul class="list-inline pr-0 m-0">
              <li class="list-inline-item text-secondary">مبلغ جریمه :</li>
              <li class="list-inline-item text-danger bnp-lblFontHampa">{{ wwwJarime }} ريال</li>
            </ul>
            <hr />
          </div>
          <div class="col-12 mt-3 text-right">
            <span class="text-dark">مبلـــغ واریزی</span>
            <input id="MabGhest" dir="ltr" class="form-control text-center 3ragham mt-1" @keypress="$ValidNumber($event, 11)" style="font-size: 14px !important" v-model="Mablagh" :disabled="(FixVariz && IsTashilat) || (FixVariz && costCode == 8)" />
          </div>
          <div class="col-12 mt-3 text-center">
            <span class="d-block" style="font-size: 14px !important">{{ Mab2persian }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-right">
            <div class="border-bottom border-warning pb-2">
              <b style="font-size: 15px !important" class="text-dark"> اطلاعات واریز کننده</b>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 text-right">
            <span class="no-wrap">مشخصات </span>
          </div>
          <div class="col-12 text-right">
            <small>{{ txtNameFamilyVarizi != '' ? txtNameFamilyVarizi : nameFamily }}</small>
          </div>
          <div class="col-12 text-right mt-2">
            <span class="no-wrap">کد ملی </span>
          </div>
          <div class="col-12 text-right mt-2">
            <small> {{ codeMeli }} </small>
          </div>
          <div class="col-12 text-right mt-2">
            <span class="no-wrap">همراه </span>
          </div>
          <div class="col-12 text-right mt-2">
            <small> {{ mobile }} </small>
          </div>
          <!-- <div class="col-12 mt-3 text-right">
            <span class="text-dark">ایمیل </span>
            <input v-model="Email" type="email" class="form-control text-center mt-1"
              style="font-size: 14px !important" />
          </div> -->
          <div class="col-12 mt-3 text-right">
            <small>توضیحات واریزی</small>
            <textarea id="Des" class="form-control text-right mt-1" rows="2" v-model="Des"></textarea>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 text-center">
            <payment @GatewayCode="Get_GatewayCode" @FixVarizGhest="FixVarizGhest">
              <template v-slot:ContentButtonPayment>
                <button :disabled="Mablagh.replace(/,/g, '') < 10000 ? true : false" class="btn btn-success w-50" @click="Payment">واریز {{ GetMablagh }}</button>
              </template>
            </payment>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Payment from './Payment.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import loading from '../Tools/NetPa/Loading.vue'
import Num2persian from 'num2persian'
export default {
  data() {
    return {
      MabFormulaJarime: 0,
      CheckUpMablagh: null,
      DataAxios_TokenResult: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TokenResult/NetPaToken',
      },
      DataAxios_TaahodatHampa: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatHampa',
      },
      DataAxios_SelAza: {
        ArryfildValue: '',
        Method: 'post',
        Action: 'SelAza/Hampa',
      },
      DataAxios_TaahodatById: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByIdNetpa',
      },
      DataAxios_ListTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/NetPa',
      },
      DataAxios_CheckUpMande: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'CheckUpMande',
      },
      DataAxiosFastPaymnet: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Fastpayment',
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: '',
      },
      IsTashilat: false,
      Mablagh: '0',
      Email: '',
      Des: '',
      GatewayCode: null,
      FixVariz: false,
      IsToken: null,
      tarihkSarsid: null,
      vCode: '',
      shenaseVariz: '',
      shenase: null,
      nameFamily: '',
      txtNameFamilyVarizi: '',
      mobile: '',
      id: null,
      codeMeli: '',
      AzaID: null,
      resTaahodatId: null,
      wwwJarime: 0,
      costCode: null,
      wwwtblShobeId: 0,
      FastpaymentData: [],
      SumMabFastPay: 0,
      SumJarmieFastPay: 0,
      VamCoutFastPay: 0,
      TablooLength: 0,
      IsFastPayment: true,
      SumMablagh: 0,
      bnpCashDBtblAzaId: 0,
      bnpCashDBtblTaahodatId: 0,
      bnpCashDbtblAzaId: 0,
      Dargah: null,
      loadingRender: false,
      DataAxios_VarizGorohi: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      tblcustomer: {},
    }
  },
  components: {
    Payment,
    NetPaCard,
    loading,
  },
  mounted() {
    this.$GetAppsettingsAsync().then(() => {
      this.gettblCustomer()
      if (this.$route.query.SarfaslTypeId == '1') {
        this.IsTashilat = true
      } else {
        this.IsTashilat = false
      }
      this.GetDataHampa()
        .then((data) => {
          if (!data) {
            this.loadingRender = true
          }
        })
        .finally(() => {
          if (!this.IsFastPayment) {
            document.getElementById('MabGhest').focus()
          } else {
            this.$Gateway().then((data) => {
              if (data.status == 'Ok') {
                data.data.forEach((element) => {
                  if ((element.gatewayCode != null || element.gatewayCode != '') && element.isDefault == true) {
                    this.Dargah = element.id
                  }
                })
              } else {
                this.$mySweetDefaultTost('عدم وجود اطلاعات', data.msg, 'warning', 2000)
              }
            })
          }
        })
        .catch((error) => {
          console.error(error)
        })
    })
  },
  updated() {
    this.$PutCommatoInput()
    // if (!this.IsFastPayment) {
    //   var mab = document.getElementById('MabGhest')
    //   if (mab.value.trim() == '') {
    //     document.getElementById('MabGhest').focus()
    //     document.getElementById('Des').value = ''
    //     this.$mySweetDefaultTost('مبلغ واریزی خالی می باشد', 'لطفا در ابتدا مبلغ واریزی را وارد نمایید', 'info', 2000)
    //   }
    // }
  },
  computed: {
    Mab2persian() {
      var Mab = this.Mablagh.replace(/,/g, '')
      Mab = Mab / 10
      return Num2persian(Mab) + ' تومان '
    },
    GetMablagh() {
      var Mab = this.Mablagh.replace(/,/g, '')
      Mab = Mab / 10
      return this.$Comma3ragham(Mab) + ' تومان '
    },
    TotalFastPay() {
      var shomarande = 0
      var SumMabFastPay = 0
      var VamCoutFastPay = 0
      var SumJarmieFastPay = 0
      var listFastpay = []
      for (let index = 0; index < this.FastpaymentData.length; index++) {
        const element = this.FastpaymentData[index]
        if (element.Active) {
          shomarande++
          SumMabFastPay += element.mablghPardakht
          SumJarmieFastPay += element.wwwjarime == null ? 0 : element.wwwjarime
          listFastpay.push(element)
        }
      }
      VamCoutFastPay = shomarande
      return {
        VamCoutFastPay: VamCoutFastPay,
        SumJarmieFastPay: SumJarmieFastPay,
        SumMabFastPay: SumMabFastPay,
        listFastpay: listFastpay,
      }
    },
  },
  methods: {
    Get_GatewayCode(val) {
      this.GatewayCode = val
    },
    FixVarizGhest(val) {
      this.FixVariz = val
    },
    Payment() {
      if (this.GatewayCode == 0) {
        if (this.costCode == 801) {
          this.$swal(
            'اختلال در پرداخت با درگاه',
            "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)" ,
            'warning'
          )
        } else {
          this.$mySweetDefaultTost('عدم انتخاب درگاه', 'درگاهی برای سامانه تنظیم نشده است', 'warning', 3000)
        }
      } else {
        if (Number(this.Mablagh.replaceAll(/,/g, '')) < Number(this.CheckUpMablagh)) {
          var MablaghJarime = this.wwwJarime
          this.MabFormulaJarime = (Number(this.Mablagh.replaceAll(/,/g, '')) / (Number(this.CheckUpMablagh) - MablaghJarime)) * MablaghJarime
        }
        const WwwtblVarizGorohiRiz = []
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId: Number(this.$route.query.TaahodatId),
          Mablagh: Number(this.Mablagh.replaceAll(/,/g, '')),
          SharhRiz: this.vCode + 'پرداخت/ واریز  تکی همراه بانک ',
          WwwtblAzaId: Number(JSON.stringify(this.AzaID)),
          BnpCashDBtblTaahodatId: Number(this.bnpCashDBtblTaahodatId),
          BnpCashDBtblAzaId: this.bnpCashDbtblAzaId,
          MablaghJarime: Math.floor(this.MabFormulaJarime),
          TarixGhest: this.tarihkSarsid,
        })
        ;(this.DataAxios_VarizGorohi.ArryfildValue.Mablagh = Number(this.Mablagh.replaceAll(/,/g, ''))), (this.DataAxios_VarizGorohi.ArryfildValue.CodeRahgiri = 0)
        this.DataAxios_VarizGorohi.ArryfildValue.Tarix = this.$store.state.JalaliDate
        this.DataAxios_VarizGorohi.ArryfildValue.Sharh = 'پرداخت/ واریز  همراه بانک'
        this.DataAxios_VarizGorohi.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
        this.DataAxios_VarizGorohi.ArryfildValue.CustCode = Number(this.tblcustomer.custCode)
        this.DataAxios_VarizGorohi.ArryfildValue.tblComboIdVaziatGrp312 = 5538
        ;(this.DataAxios_VarizGorohi.ArryfildValue.wwwtblAzaId = this.AzaID), (this.DataAxios_VarizGorohi.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz)
        this.$PostData(this.DataAxios_VarizGorohi).then((result) => {
          if (result.status === 'Success') {
            this.$Payment(
              this.GatewayCode + '',
              this.Mablagh.replaceAll(/,/g, ''),
              this.txtNameFamilyVarizi != '' ? this.txtNameFamilyVarizi : this.nameFamily,
              this.Email,
              this.mobile,
              Number(this.$route.query.TaahodatId),
              this.shenaseVariz == '' ? '' : this.shenaseVariz,
              this.vCode,
              this.Des,
              this.$route.query.tblAzaIdVariz > 0 ? this.$route.query.tblAzaIdVariz + '' : this.AzaID + '',
              this.costCode,
              JSON.stringify(this.wwwtblShobeId),
              result.idRepoMaster,
              this.codeMeli
            )
          } else {
            this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 2000)
            this.DeleteAllItemsCart()
          }
        })

        this.loadingRender = true
        // this.$Payment(this.GatewayCode+"",
        // this.Mablagh,
        // this.nameFamily,
        // this.Email,
        // this.mobile,
        // Number(this.$route.query.TaahodatId),
        // this.shenaseVariz,
        // this.vCode,
        // this.Des,
        // JSON.stringify(this.AzaID),
        // this.costCode,
        // JSON.stringify(this.wwwtblShobeId),
        // 0,
        // this.codeMeli);
        this.loadingRender = false
      }
    },
    GetDataHampa() {
      return new Promise((resolve) => {
        this.loadingRender = true
        resolve(false)
        const formData = new FormData()
        formData.append('Token', this.$route.query.Token)
        this.DataAxios_TokenResult.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_TokenResult)
          .then((data) => {
            this.costCode = data.custCode.substring(1, 4)
            if (data.result == 'Failed') {
              this.$mySweetDefaultTost('عدم وجود اطلاعات', 'توکن ارسالی معتبر نمیباشد.', 'warning', 2000)
            } else {
              this.Token = data.result
            }
          })
          .finally(() => {
            if (this.Token) {
              if (this.$route.query.IsUSSD == undefined) {
                this.$session.set('TokenHampa', true)
              }
              const formData = new FormData()
              formData.append('TaahodatId', this.$route.query.TaahodatId)
              formData.append('wwwtblSarfaslTypeId', this.$route.query.SarfaslTypeId)
              this.DataAxios_TaahodatHampa.ArryfildValue = formData
              this.$PostFormData(this.DataAxios_TaahodatHampa)
                .then((data) => {
                  this.nameFamily = data.nameFamily
                  this.vCode = data.vCode

                  this.codeMeli = data.codeMeli
                  this.id = data.id
                  this.mobile = data.mobile
                  this.txtNameFamilyVarizi = ''
                  this.shenase = data.shenase
                  this.shenaseVariz = data.shenaseVariz
                })
                .finally(() => {
                  if (this.$route.query.wwwtblAzaId > 0) {
                    this.GetFastpaymentData()
                    this.loadingRender = false
                    resolve(true)
                    return
                  }

                  if (this.$route.query.tblAzaIdVariz > 0) {
                    const formData = new FormData()
                    formData.append('wwwtblAzaId', this.$route.query.tblAzaIdVariz)
                    this.DataAxios_SelAza.ArryfildValue = formData
                    this.$PostFormData(this.DataAxios_SelAza).then((data) => {
                      this.codeMeli = data.codeMeli
                      this.id = data.id
                      this.mobile = data.mobile
                      this.txtNameFamilyVarizi = data.ozvName + ' ' + data.ozvFamily
                      // this.resTaahodatId = data.filter(
                      //   (x) => x.id == this.$route.query.TaahodatId
                      // );
                      // this.bnpCashDBtblAzaId =
                      //   this.resTaahodatId[0].bnpCashDBtblAzaId;
                      // this.BnpCashDBtblTaahodatId =
                      //   this.resTaahodatId[0].BnpCashDBtblTaahodatId;
                      // this.wwwtblShobeId =
                      //   this.resTaahodatId[0].wwwtblShobeId;
                    })
                    // .finally(() => {
                    //   this.GetFastpaymentData();
                    //   this.loadingRender = false;
                    //   resolve(true);
                    // });
                  }

                  if (this.$route.query.SarfaslTypeId == '1') {
                    //vam

                    this.IsFastPayment = false
                    const formData = new FormData()
                    formData.append('Id', this.$route.query.TaahodatId)
                    this.DataAxios_TaahodatById.ArryfildValue = formData
                    this.$PostFormData(this.DataAxios_TaahodatById)
                      .then((data) => {
                        this.bnpCashDBtblTaahodatId = data[0].bnpCashDbtblTaahodatId
                        this.bnpCashDbtblAzaId = data[0].bnpCashDbtblAzaId
                        this.AzaID = data[0].wwwtblAzaId
                        this.wwwtblShobeId = data.wwwtblShobeId
                      })
                      .finally(() => {
                        // this.AzaID=this.$route.query.tblAzaIdVariz
                        const formData = new FormData()
                        formData.append('wwwtblAzaId', this.AzaID)
                        formData.append('wwwtblSarfaslTypeId', 1)
                        this.DataAxios_ListTaahodat.ArryfildValue = formData
                        this.$PostFormData(this.DataAxios_ListTaahodat)
                          .then((data) => {
                            this.resTaahodatId = data.filter((x) => x.id == this.$route.query.TaahodatId)
                            this.wwwtblShobeId = this.resTaahodatId[0].wwwtblShobeId
                            this.tarihkSarsid = this.resTaahodatId[0].minTarGhestBedehkar == '' ? this.resTaahodatId[0].tarixShoroAghsat : this.resTaahodatId[0].minTarGhestBedehkar
                          })
                          .finally(() => {
                            const formData = new FormData()
                            formData.append('wwwtblTaahodatId', this.resTaahodatId[0].id)
                            this.DataAxios_CheckUpMande.ArryfildValue = formData
                            this.$PostFormData(this.DataAxios_CheckUpMande).then((data) => {
                              if (data.length != 0) {
                                console.log('/*/*/*/')
                              }
                            })
                            this.wwwJarime = this.resTaahodatId[0].wwwJarime != null ? this.resTaahodatId[0].wwwJarime : 0
                            if (this.costCode == 8) {
                              this.Mablagh = this.resTaahodatId[0].mabAvalinForPar + ''
                            } else {
                              this.Mablagh = this.resTaahodatId[0].sumGhabelPar + ''
                            }
                            this.CheckUpMablagh = this.resTaahodatId[0].sumGhabelPar
                          })
                      })
                    this.loadingRender = false
                    resolve(true)
                  } else {
                    this.IsFastPayment = false
                    const formData = new FormData()
                    formData.append('Id', this.$route.query.TaahodatId)
                    this.DataAxios_TaahodatById.ArryfildValue = formData
                    this.$PostFormData(this.DataAxios_TaahodatById)
                      .then((data) => {
                        this.bnpCashDBtblTaahodatId = data[0].bnpCashDbtblTaahodatId
                        this.bnpCashDbtblAzaId = data[0].bnpCashDbtblAzaId
                        this.AzaID = data[0].wwwtblAzaId
                        this.wwwtblShobeId = data.wwwtblShobeId
                      })
                      .finally(() => {
                        // this.AzaID=this.$route.query.tblAzaIdVariz
                        const formData = new FormData()
                        formData.append('wwwtblAzaId', this.AzaID)
                        formData.append('wwwtblSarfaslTypeId', 2)
                        this.DataAxios_ListTaahodat.ArryfildValue = formData
                        this.$PostFormData(this.DataAxios_ListTaahodat)
                          .then((data) => {
                            this.resTaahodatId = data.filter((x) => x.id == this.$route.query.TaahodatId)
                            this.wwwtblShobeId = this.resTaahodatId[0].wwwtblShobeId
                            this.tarihkSarsid = this.resTaahodatId[0].minTarGhestBedehkar == '          ' ? this.resTaahodatId[0].tarixShoroAghsat : this.resTaahodatId[0].minTarGhestBedehkar
                          })
                          .finally(() => {
                            const formData = new FormData()
                            formData.append('wwwtblTaahodatId', this.resTaahodatId[0].id)
                            this.DataAxios_CheckUpMande.ArryfildValue = formData
                            this.$PostFormData(this.DataAxios_CheckUpMande).then((data) => {
                              if (data.length != 0) {
                                console.log('/*/*/*/')
                              }
                            })
                            this.wwwJarime = this.resTaahodatId[0].wwwJarime != null ? this.resTaahodatId[0].wwwJarime : 0
                            this.Mablagh = this.resTaahodatId[0].mablaghSharj > 0 ? this.resTaahodatId[0].mablaghSharj + '' : '0'
                          })
                      })
                    this.loadingRender = false
                    resolve(true)
                  }
                })
            }
          })
      })
    },
    GetFastpaymentData() {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$route.query.wwwtblAzaId)
      this.DataAxiosFastPaymnet.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosFastPaymnet).then((data) => {
        if (data.data.length > 0) {
          for (var i = 0; i < data.data.length; i++) {
            var element = data.data[i]
            data.data[i].Active = true
            this.SumJarmieFastPay += element.wwwjarime == null ? 0 : element.wwwjarime
          }
          this.FastpaymentData = data.data
          this.loadingRender = false
        } else {
          this.loadingRender = false
        }
      })
    },
    FastPay() {
      this.loadingRender = true
      const WwwtblVarizGorohiRiz = []
      for (let index = 0; index < this.TotalFastPay.listFastpay.length; index++) {
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId: this.TotalFastPay.listFastpay[index].id,
          Mablagh: this.TotalFastPay.listFastpay[index].mablghPardakht,
          SharhRiz: 'همراه بانک پرداخت قسط تسهیلات ' + this.TotalFastPay.listFastpay[index].vCode,
          WwwtblAzaId: Number(this.$route.query.wwwtblAzaId),
          BnpCashDBtblTaahodatId: this.TotalFastPay.listFastpay[index].bnpCashDBtblTaahodatId,
          BnpCashDBtblAzaId: this.bnpCashDBtblAzaId,
          MablaghJarime: Number(this.TotalFastPay.listFastpay[index].wwwjarime) == null ? 0 : Number(this.TotalFastPay.listFastpay[index].wwwjarime),
          TarixGhest: this.TotalFastPay.listFastpay[index].minTarGhestBedehkar,
        })
      }
      this.SumMablagh = this.TotalFastPay.SumMabFastPay
      this.DataAxios_Variz.ArryfildValue.Mablagh = this.SumMablagh
      this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.Sharh = ' همراه بانک پرداخت اقساط گروهی'
      this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.costCode)
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = Number(5538)
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = Number(this.$route.query.wwwtblAzaId)
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz

      this.$PostData(this.DataAxios_Variz).then((result) => {
        this.$Payment(
          JSON.stringify(this.Dargah),
          JSON.stringify(this.SumMablagh),
          this.nameFamily,
          this.Email,
          this.mobile,
          WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
          this.shenaseVariz == '' ? '' : this.shenaseVariz,
          this.vCode,
          'همراه بانک پرداخت گروهی توسط پرداخت سریع',
          JSON.stringify(Number(this.$route.query.wwwtblAzaId)),
          this.costCode,
          JSON.stringify(this.wwwtblShobeId),
          result.idRepoMaster,
          this.codeMeli
        )
      })
      this.loadingRender = false
    },
    gettblCustomer() {
      this.$PostData({
        ArryfildValue: {},
        Action: 'GetTblCustomer',
        method: 'GET',
        Token: '',
      }).then((data) => {
        this.tblcustomer = data
      })
    },
  },
}
</script>
<style scoped>
.bnp-lblFontHampa {
  font-size: 14px !important;
  font-weight: bold !important;
}
</style>
